import { MAX_UPLOAD_FILE_SIZE } from '../constants';
import { allowedExtensions } from './GlobalConstantUtils';

export const validateFile = (file: File) => {
  const fileExtension = file.name.includes('.')
    ? `.${file.name.split('.').pop()?.toLowerCase()}`
    : '';
  return allowedExtensions.includes(fileExtension);
};

export const validateFileSize = (file: File) => {
  return file.size > MAX_UPLOAD_FILE_SIZE;
};

export const isStringArrayEqual = (
  a?: string[] | null,
  b?: string[] | null,
): boolean => {
  const normalize = (value?: string[] | null) =>
    (value ?? []).map((item) => item.trim().toLowerCase()).sort();

  const first = normalize(a);
  const second = normalize(b);

  if (first.length !== second.length) {
    return false;
  }

  return first.every((item, index) => item === second[index]);
};
